// extracted by mini-css-extract-plugin
export default {"price":"M5-z","onSale":"N5-z","msrpLabelPrice":"O5-z","msrpLabel":"P5-z","originalPrice":"Q5-z","percentOff":"R5-z"};